var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7H3V5h3.5v2ZM21 7h-9.5V5H21v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5c-.83 0-1.5.67-1.5 1.5 0 .82.67 1.5 1.5 1.5 .82 0 1.5-.68 1.5-1.5 0-.83-.68-1.5-1.5-1.5ZM5.5 6c0-1.94 1.56-3.5 3.5-3.5 1.93 0 3.5 1.56 3.5 3.5 0 1.93-1.57 3.5-3.5 3.5 -1.94 0-3.5-1.57-3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13h2v-2h-2v2ZM3 13h11v-2H3v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5c.82 0 1.5.67 1.5 1.5 0 .82-.68 1.5-1.5 1.5 -.83 0-1.5-.68-1.5-1.5 0-.83.67-1.5 1.5-1.5ZM20 12c0-1.94-1.57-3.5-3.5-3.5 -1.94 0-3.5 1.56-3.5 3.5 0 1.93 1.56 3.5 3.5 3.5 1.93 0 3.5-1.57 3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19H3v-2h5v2Zm13 0h-8v-2h8v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5c-.83 0-1.5.67-1.5 1.5 0 .82.67 1.5 1.5 1.5 .82 0 1.5-.68 1.5-1.5 0-.83-.68-1.5-1.5-1.5ZM7 18c0-1.94 1.56-3.5 3.5-3.5 1.93 0 3.5 1.56 3.5 3.5 0 1.93-1.57 3.5-3.5 3.5C8.56 21.5 7 19.93 7 18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting1);
export default __webpack_public_path__ + "static/media/setting 1.e6dcbe0cc944ef61c41b6cdcd84df56c.svg";
export { ForwardRef as ReactComponent };